import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { fetchPlayer, type PlayerDetailResponse, type BEPlayerDetail } from '@/lib/network';

const PLAYER_STALE_TIME_MS = 2 * 60 * 1000;
const PLAYER_GC_TIME_MS = 5 * 60 * 1000;

export type UseFetchPlayerOptions = Omit<
  UseQueryOptions<PlayerDetailResponse, Error>,
  'queryKey' | 'queryFn' | 'select'
>;

interface UseFetchPlayerProps {
  playerId: string | undefined;
  periodId?: string;
  periodType: 'gameweek' | 'matchday';
  fullFixtures?: boolean;
  limitFixture?: number;
  options?: UseFetchPlayerOptions;
}

export const useFetchPlayer = ({
  playerId,
  periodId,
  periodType = 'matchday',
  fullFixtures,
  limitFixture,
  options,
}: UseFetchPlayerProps) => {
  return useQuery<PlayerDetailResponse, Error, BEPlayerDetail>({
    queryKey: ['player', playerId, periodId, periodType, fullFixtures, limitFixture],
    queryFn: () => {
      if (!playerId) {
        throw new Error('Player ID is required');
      }
      return fetchPlayer({ playerId, periodId, periodType, fullFixtures, limitFixture });
    },
    enabled: !!playerId,
    staleTime: PLAYER_STALE_TIME_MS,
    gcTime: PLAYER_GC_TIME_MS,
    select: response => response.data,
    ...options,
  });
};
